"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionListToDataFeedMessage = exports.unionToDataFeedMessage = exports.DataFeedMessage = void 0;
const data_feed_config_js_1 = require("../../solarxr-protocol/data-feed/data-feed-config.js");
const data_feed_update_js_1 = require("../../solarxr-protocol/data-feed/data-feed-update.js");
const poll_data_feed_js_1 = require("../../solarxr-protocol/data-feed/poll-data-feed.js");
const start_data_feed_js_1 = require("../../solarxr-protocol/data-feed/start-data-feed.js");
var DataFeedMessage;
(function (DataFeedMessage) {
    DataFeedMessage[DataFeedMessage["NONE"] = 0] = "NONE";
    DataFeedMessage[DataFeedMessage["PollDataFeed"] = 1] = "PollDataFeed";
    DataFeedMessage[DataFeedMessage["StartDataFeed"] = 2] = "StartDataFeed";
    DataFeedMessage[DataFeedMessage["DataFeedUpdate"] = 3] = "DataFeedUpdate";
    DataFeedMessage[DataFeedMessage["DataFeedConfig"] = 4] = "DataFeedConfig";
})(DataFeedMessage = exports.DataFeedMessage || (exports.DataFeedMessage = {}));
function unionToDataFeedMessage(type, accessor) {
    switch (DataFeedMessage[type]) {
        case 'NONE': return null;
        case 'PollDataFeed': return accessor(new poll_data_feed_js_1.PollDataFeed());
        case 'StartDataFeed': return accessor(new start_data_feed_js_1.StartDataFeed());
        case 'DataFeedUpdate': return accessor(new data_feed_update_js_1.DataFeedUpdate());
        case 'DataFeedConfig': return accessor(new data_feed_config_js_1.DataFeedConfig());
        default: return null;
    }
}
exports.unionToDataFeedMessage = unionToDataFeedMessage;
function unionListToDataFeedMessage(type, accessor, index) {
    switch (DataFeedMessage[type]) {
        case 'NONE': return null;
        case 'PollDataFeed': return accessor(index, new poll_data_feed_js_1.PollDataFeed());
        case 'StartDataFeed': return accessor(index, new start_data_feed_js_1.StartDataFeed());
        case 'DataFeedUpdate': return accessor(index, new data_feed_update_js_1.DataFeedUpdate());
        case 'DataFeedConfig': return accessor(index, new data_feed_config_js_1.DataFeedConfig());
        default: return null;
    }
}
exports.unionListToDataFeedMessage = unionListToDataFeedMessage;
